<template>
  <div class="container">
    <div class="handle-box">
      <el-form :model="queryCondition" ref="queryCondition" label-width="120px" class="searchForm">
        <el-row>
          <el-col :span="24">
            <el-row :gutter="20">
              <el-col :span="6">
                <el-form-item :label="$t('material.GRICode')" prop="fiveBitCode">
                  <el-input v-model.trim="queryCondition.fiveBitCode" clearable style="width:100%"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item :label="$t('material.fiveBitCodeName')" prop="fiveBitCodeName">
                  <el-input v-model.trim="queryCondition.fiveBitCodeName" clearable style="width:100%"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item :label="$t('common.status')" prop="status">
                  <ic-select v-model="queryCondition.status" table="TM_FIVE_BIT_CODE" field="STATUS" clearable style="width:100%"></ic-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="Category1" prop="categoryLevel1Id">
                  <el-select v-model="queryCondition.categoryLevel1Id" clearable @change="changeCategory1()" style="width:100%">
                    <el-option :key="index" v-for="(item,index) in categoryList1" :label="item.name" :value="item.tmCategoryId"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
          <el-collapse-transition>
            <el-col :span="24" v-if="isShow">
              <el-row :gutter="20">
                <el-col :span="6">
                  <el-form-item label="Category2" prop="categoryLevel2Id">
                    <el-select v-model="queryCondition.categoryLevel2Id" clearable @change="changeCategory2()" style="width:100%">
                      <el-option :key="index" v-for="(item,index) in categoryList2" :label="item.name" :value="item.tmCategoryId"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="Category3" prop="categoryLevel3Id">
                    <el-select v-model="queryCondition.categoryLevel3Id" clearable style="width:100%">
                      <el-option :key="index" v-for="(item,index) in categoryList3" :label="item.name" :value="item.tmCategoryId"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-col>
          </el-collapse-transition>
        </el-row>
        <el-row type="flex" justify="center" align="middle">
          <el-button size="mini" @click="queryData(1)" type="primary">{{$t('common.search')}}</el-button>
          <el-button size="mini" @click="restQueryForm" type="primary">{{$t('common.reset')}}</el-button>
          <span class="arrowDown" @click="isShow=!isShow">{{isShow?'收缩':'展开'}}<i :class="isShow?'el-icon-arrow-up iconBtn':'el-icon-arrow-down iconBtn'"></i></span>
        </el-row>
      </el-form>
    </div>
    <div class="action-btn-row">
      <el-button size="mini" class="btn" v-if="griAdd" type="primary" @click="addGRI()">{{$t('common.newBuilt')}}</el-button>
      <el-button size="mini" class="btn" v-acl="GRI_COOK_CONFIG" type="primary" @click="onCook">烹饪方式维护</el-button>
      <el-button size="mini" class="btn" v-if="griDelete" type="danger" @click="telGRI()">{{$t('common.del')}}</el-button>
      <el-button size="mini" class="btn" v-if="griDownload" type="primary" @click="download">{{$t('common.download')}}
      </el-button>
    </div>
    <el-table :data="tableList" row-key="tmFiveBitCodeId" ref="tableList" border highlight-current-row max-height="420">
      <el-table-column fixed sortable type="selection" width="55" align="center" :reserve-selection="true"></el-table-column>
      <el-table-column show-overflow-tooltip　prop="fiveBitCode" :label="$t('material.GRICode')" min-width="60">
        <template slot-scope="scope">
          <div class="a-link" @click="toDetail(scope.row.tmFiveBitCodeId)">{{scope.row.fiveBitCode}}</div>
        </template>
      </el-table-column>
      <el-table-column show-overflow-tooltip　prop="categoryLevel1Name" :label="$t('material.categoryLevel1Name')" min-width="90"></el-table-column>
      <el-table-column show-overflow-tooltip　prop="categoryLevel2Name" :label="$t('material.categoryLevel2Name')" min-width="90"></el-table-column>
      <el-table-column show-overflow-tooltip　prop="categoryLevel3Name" :label="$t('material.categoryLevel3Name')" min-width="90"></el-table-column>
      <el-table-column show-overflow-tooltip　prop="fiveBitCodeName" :label="$t('material.fiveBitCodeName')" min-width="130"></el-table-column>
      <el-table-column show-overflow-tooltip　prop="describe" :label="$t('material.describe')" min-width="150"></el-table-column>
      <el-table-column show-overflow-tooltip　prop="cookNames" label="烹饪方式" min-width="150"></el-table-column>
      <el-table-column prop="createDate" :label="$t('common.createDate')" min-width="80">
        <template slot-scope="scope">{{scope.row.createDate | dateFormatFilter("YYYY-MM-DD")}}</template>
      </el-table-column>
      <el-table-column show-overflow-tooltip　prop="fromEffectiveDate" :label="$t('material.fromEffectiveDate')" min-width="90"></el-table-column>
      <el-table-column prop="statusI18n" label="GRI状态" min-width="60"></el-table-column>
      <el-table-column prop="conductStatusI18n" label="审批状态" min-width="70"></el-table-column>
      <el-table-column prop="invalidDate" :label="$t('material.invalidDate')" min-width="80"></el-table-column>
      <el-table-column prop="inventoryCountingFrequency" :label="$t('material.inventoryCountingFrequency')" min-width="80"></el-table-column>
      <el-table-column show-overflow-tooltip prop="menuTypeI18n" :label="$t('material.menuType')" min-width="70"></el-table-column>
      <el-table-column prop="storageCategoryI18n" :label="$t('material.storageCategory')" min-width="80"></el-table-column>
      <el-table-column prop="uomI18n" label="UOM" min-width="50"></el-table-column>
      <el-table-column prop="standardCopiesUom" :label="$t('material.standardCopiesUom')" min-width="110"></el-table-column>
      <el-table-column prop="isDisplayBtrReportI18n" :label="$t('material.isDisplayBtrReport')" min-width="110"></el-table-column>
      <el-table-column prop="btrUsageAreaI18n" :label="$t('material.btrUsageArea')" min-width="90"></el-table-column>
      <el-table-column prop="btrUnitMeasurement" :label="$t('material.btrUnitMeasurement')" min-width="90"></el-table-column>
      <!-- <el-table-column prop="isConsignment" label="是否寄售" min-width="90">
         <template slot-scope="scope">{{ scope.row.isConsignment | ic("TM_MATERIAL_RECORD", "IS_NOT") }}</template>
      </el-table-column> -->
      <el-table-column show-overflow-tooltip　prop="createUserName" :label="$t('common.createBy')" min-width="80"></el-table-column>
    </el-table>
    <div class="pagination">
      <el-pagination @size-change="pageSizeChange" @current-change="pageNumberChange" :current-page="queryCondition.pageNum" :page-sizes="pageSizeList" :page-size="queryCondition.pageSize" :layout="pageLayout" :total="totalCount"></el-pagination>
    </div>
    <el-dialog title="烹饪方式维护" :visible.sync="dialogVisible" width="50%" :close-on-click-modal="false" @close="onClose" class="fpa">
      <el-form ref="cookForm" :model="cookForm">
        <el-row>
          <el-col>
            <el-form-item label="GRI编码" prop="griCode" label-width="100px">
              <el-input v-model="cookForm.griCode" disabled style="width:100%"></el-input>
            </el-form-item>
          </el-col>
          <el-col>
            <el-form-item label="GRI名称" prop="griName" label-width="100px">
              <el-input v-model="cookForm.griName" disabled style="width:100%"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-table :data="cookForm.itemList" ref="elTable" row-key="sortNum" max-height="344px" border size="small" style="width: 100%">
          <el-table-column min-width="60px">
            <template slot="header" slot-scope="scope">
              <el-button size="mini" type="primary" plain @click="onAdd(scope.$index,scope.row)" style="padding:1px!important;backgroundColor:#f8ab01!important"><i class="el-icon-plus"></i></el-button>
            </template>
            <template slot-scope="scope">
              <el-button size="mini" v-if="scope.row.canOperate&&cookForm.itemList.length>1" type="danger" @click="onDelete(scope.$index,scope.row)" style="padding:1px!important;"><i class="el-icon-delete"></i></el-button>
            </template>
          </el-table-column>
          <el-table-column prop="cookCode" label="烹饪方式" :render-header="renderHeader" min-width="200px">
            <template slot-scope="scope">
              <el-form-item :prop="`itemList.${scope.$index}.cookCode`" :rules="cookNamesRules(scope.$index,scope.row)">
                <ic-select table="TR_NUTR_GRI_COOK" field="COOK_CODE" :disabled="!scope.row.canOperate" clearable v-model="scope.row.cookCode" style="width:100%"></ic-select>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column prop="needInspect" label="需要检测标识" :render-header="renderHeader" min-width="180px">
            <template slot-scope="scope">
              <el-form-item :prop="`itemList.${scope.$index}.needInspect`" :rules="needInspectRules(scope.$index,scope.row)">
                <ic-select table="TT_NUTR_INGREDIENT" field="NEED_INSPECT" clearable v-model="scope.row.needInspect" style="width:100%"></ic-select>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column prop="comments" label="备注" min-width="180px">
            <template slot-scope="scope">
              <el-form-item :prop="`itemList.${scope.$index}.comments`">
                <el-input v-model="scope.row.comments" type="textarea" :rows="1" style="width:100%"></el-input>
              </el-form-item>
            </template>
          </el-table-column>
        </el-table>
      </el-form>
      <el-row type="flex" justify="center" style="margin-top:10px">
        <el-button size="mini" class="btn" type="primary" @click="onSave">保存</el-button>
        <el-button size="mini" class="btn" @click="onClose">取消</el-button>
      </el-row>
    </el-dialog>
  </div>
</template>
<script>
import { apiService } from "@/api/material/material-master-data";
import IcSelect from "@/components/common/icSelect";
import commonFunction from "@/utils/dataTableUtils";
import GRIApi from "@/api/material/GRI";
import { Message } from "element-ui";

export default {
  components: { IcSelect },
  name: "",

  data() {
    return {
      isShow: false,//控制查询列表收缩展开
      queryCondition: {
        pageNum: 1,
        pageSize: 15,
        categoryLevel1Id: null,
        categoryLevel2Id: null,
        categoryLevel3Id: null,
        fiveBitCode: '',
        fiveBitCodeName: '',
      },
      tableList: [],
      totalCount: 0,
      categoryList1: [],
      categoryList2: [],
      categoryList3: [],
      griAdd: false,
      griDelete: false,
      griDownload: false,
      dialogVisible: false,
      cookForm: {
        griCode: "",
        griName: "",
        griId: "",
        itemList: [],
        comments: "",
      },
      rules: {}
    };
  },
  created() {
    if (this.$route.query.fiveBitCode) {
      this.queryCondition.fiveBitCode = this.$route.query.fiveBitCode
    }
    this.queryData();
    this.getCategoryList(1)
    this.getUserType()
  },

  methods: {
    queryData(val) {
      let that = this;
      if (undefined != val) {
        this.queryCondition.pageNum = 1;
      }
      GRIApi.getList(this.queryCondition).then((res) => {
        console.log(res);
        that.tableList = res.resultData;
        that.totalCount = res.totalCount;
        this.$refs.tableList.clearSelection()
      });
    },
    restQueryForm() {
      this.$refs['queryCondition'].resetFields();
      this.queryCondition = {
        pageNum: 1,
        pageSize: 15,
        categoryLevel1Id: null,
        categoryLevel2Id: null,
        categoryLevel3Id: null,
        fiveBitCode: '',
        fiveBitCodeName: '',
      }
      this.$refs.tableList.clearSelection()
      this.queryData();
    },
    toDetail(id) {
      this.$router.push({
        path: `/materialGRIDetail`,
        query: {
          id: id
        }
      });
    },
    addGRI() {
      this.$router.push({
        path: `/materialGRIDetail`,
        query: {
          type: "newCreate"
        }
      });
    },
    onCook() {
      let rows = this.$refs.tableList.selection;
      console.log("🚀 ~ file: materialGRI.vue:237 ~ onCook ~ rows:", rows)
      if (rows.length === 0) {
        this.$message.error("请至少勾选一条数据")
        return false
      }
      if (rows.length > 1) {
        this.$message.error("仅可勾选一条数据")
        return false
      }
      apiService.getCook(rows[0].tmFiveBitCodeId).then((res) => {
        console.log("🚀 ~ file: materialGRI.vue:248 ~ GRIApi.getCook ~ res:", res)
        if (res.code == '200') {
          this.cookForm.griCode = res.data.griCode
          this.cookForm.griName = res.data.griName
          this.cookForm.griId = res.data.griId
          this.cookForm.comments = res.data.comments
          this.cookForm.itemList = res.data.itemList
          this.dialogVisible = true;
        }
      })
    },
    onAdd(index, row) {
      var item = {
        cookCode: "",
        needInspect: "",
        comments: "",
        canOperate: true
      }
      this.cookForm.itemList.push(item)
    },
    onDelete(index, row) {
      this.$confirm('请确认是否删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.cookForm.itemList.splice(index, 1)
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    onSave() {
      this.$refs['cookForm'].validate((valid) => {
        if (valid) {
          console.log('1231231')
          apiService.saveCook(this.cookForm).then((res) => {
            console.log("🚀 ~ file: materialGRI.vue:281 ~ apiService.saveCook ~ res:", res)
            if (res.code == '200') {
              this.$message.success('保存成功')
              this.onClose()
              this.queryData();
            }
          })
        }
      })
    },
    onClose() {
      this.dialogVisible = false;
      this.cookForm = {
        griCode: "",
        griName: "",
        griId: "",
        tableData: []
      }
    },
    needInspectRules(index, row) {
      return (this.rules["needInspect"] = [
        {
          validator: (rule, value, callback) => {
            // 验证不为空
            if (!value) {
              return callback(new Error('请选择需要检测标识'));
            }
            callback();
          },
          trigger: "change"
        }
      ]);
    },
    cookNamesRules(index, row) {
      return (this.rules["cookCode"] = [
        {
          validator: (rule, value, callback) => {
            // 验证不为空
            if (!value) {
              return callback(new Error('请选择烹饪方式'));
            }
            for (var i = 0; i < this.cookForm.itemList.length - 1; i++) {
              for (var j = i + 1; j < this.cookForm.itemList.length; j++) {
                if (this.cookForm.itemList[i].cookCode === this.cookForm.itemList[j].cookCode) {
                  return callback(new Error('烹饪方式存在重复,请重新维护'));
                }
              }
            }
            callback();
          },
          trigger: "change"
        }
      ]);
    },
    async telGRI() {
      let that = this;
      let rows = this.$refs.tableList.selection;
      if (rows.length == 0) {
        that.$message({
          message: that.$t("common.pleaseSelectData"),
          type: "warning"
        });
      } else {
        let ids = rows.map(data => data.tmFiveBitCodeId)
        if (await this.callConfirm()) {
          console.log(ids)
          GRIApi.deleteBatch(ids).then((res) => {
            if (res.code === '200') {
              Message({ message: this.$t('common.delSuccess'), type: "success" });
            } else {
              Message({ message: this.$t('common.delError'), type: "error" });
            }
            this.queryData();
          });
        }
      }
    },
    getCategoryList() {
      apiService.findCategory({ categoryLevel: 1 }).then((res) => {
        res.data = res.data.map(item => ({
          ...item,
          name: item.name || ' '
        }))
        this.categoryList1 = res.data;
      });
    },
    //根据选中Category1查询Category2
    changeCategory1() {
      this.queryCondition.categoryLevel2Id = null
      this.queryCondition.categoryLevel3Id = null
      this.categoryList2 = []
      this.categoryList3 = []
      apiService.findCategory({ categoryLevel: 2, pid: this.queryCondition.categoryLevel1Id }).then((res) => {
        res.data = res.data.map(item => ({
          ...item,
          name: item.name || ' '
        }))
        this.categoryList2 = res.data;
      });
    },
    //根据选中Category2查询Category3
    changeCategory2() {
      this.queryCondition.categoryLevel3Id = null
      this.categoryList3 = []
      apiService.findCategory({ categoryLevel: 3, pid: this.queryCondition.categoryLevel2Id }).then((res) => {
        res.data = res.data.map(item => ({
          ...item,
          name: item.name || ' '
        }))
        this.categoryList3 = res.data;
      });
    },
    download() {
      GRIApi.exportList(this.queryCondition);
    },
    getUserType() {
      let permission = JSON.parse(localStorage.getItem("ms_Permission"));
      for (let i = 0, len = permission.length; i < len; i++) {
        if (permission[i] == 'gri_add') {//新建
          this.griAdd = true;
        }
        if (permission[i] == 'gri_delete') {//删除
          this.griDelete = true;
        }
        if (permission[i] == 'gri_download') {//下载
          this.griDownload = true;
        }
      }
    },
  },
  extends: commonFunction,
};
</script>
<style scoped lang="scss">
.el-select {
  width: 100%;
}
</style>
<style lang="scss">
</style>
